import { render } from "./aboutUs.vue?vue&type=template&id=50945c95&scoped=true&ts=true"
import script from "./aboutUs.vue?vue&type=script&lang=ts"
export * from "./aboutUs.vue?vue&type=script&lang=ts"

import "./aboutUs.vue?vue&type=style&index=0&id=50945c95&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50945c95"]])

export default __exports__